import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
export function FAQSection() {
  const {
    language
  } = useLanguage();
  const t = translations[language].faq;
  return <section className="py-20 px-4 bg-gradient-to-b from-teal-950 to-black" data-id="element-15">
      <div className="max-w-4xl mx-auto" data-id="element-16">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-12 text-yellow-400" data-id="element-17">
          {t.title}
        </h2>
        <div className="space-y-6" data-id="element-18">
          {t.questions.map((faq, index) => <div key={index} className="bg-gradient-to-br from-teal-950/50 to-black border border-teal-700/30 rounded-xl p-6" data-id="element-19">
              <h3 className="text-xl font-bold text-teal-300 mb-3" data-id="element-20">
                Q: {faq.q}
              </h3>
              <p className="text-lg text-gray-200" data-id="element-21">A: {faq.a}</p>
            </div>)}
        </div>
      </div>
    </section>;
}